const ROW_TYPES = ["string", "number", "date", "checkbox", "dropdown", "multiselect", "option", "sector dropdown","branch dropdown","activity dropdown","activity detail dropdown",
"region dropdown","department dropdown","city dropdown","municipality dropdown","district dropdown", "locality dropdown", "map", "total fee"]

export { ROW_TYPES }